import localforage from 'localforage';
import { readableFileSize } from '@/utils/file-size';
import { reportStorageError } from '@/utils/storage-error';

const catchStorageErrors = (storage: LocalForage) => ({
  getItem: async <S>(key: string) => {
    try {
      return await storage.getItem<S>(key);
    } catch (err) {
      await reportStorageError(err, key, 'get', storage.config().name);
      return null;
    }
  },
  setItem: async (key: string, value: unknown) => {
    try {
      return await storage.setItem(key, value);
    } catch (err) {
      await reportStorageError(err, key, 'set', storage.config().name);
    }
  },
  removeItem: async (key: string) => {
    try {
      return await storage.removeItem(key);
    } catch (err) {
      await reportStorageError(err, key, 'remove', storage.config().name);
    }
  },
});

export const dbStore = catchStorageErrors(
  localforage.createInstance({
    name: 'chat-store',
    driver: localforage.INDEXEDDB,
    storeName: 'chat-store',
  }),
);

export async function estimateStorageQuota() {
  try {
    if ('storage' in navigator && 'estimate' in navigator.storage && typeof navigator.storage.estimate === 'function') {
      const { usage = 0, quota = 0 } = await navigator.storage.estimate();

      return {
        usage: readableFileSize(usage),
        quota: readableFileSize(quota),
        ratio: Number.parseFloat(((usage / quota) * 100).toFixed(2)),
      };
    }

    return {
      usage: '0B',
      quota: '0B',
      ratio: 0.0,
    };
  } catch {
    return {
      usage: '0B',
      quota: '0B',
      ratio: 0.0,
    };
  }
}
